import { Link, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";
import { Typography } from "@mui/material";
import { getMeditationInsightsApi } from "../../services/meditationManagement";

const DashboardAnalytics = () => {
  const { id: userId } = useParams();
  const [dashboardData, setDashboardData] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // Fetch numerical analytics data
  const fetchDashboardAnalytics = async (userId) => {
    try {
      showLoader();
      const sendData = { };
      console.log("sendData", sendData);
      const { data } = await getMeditationInsightsApi(sendData);
      if (data?.code === 200) {
        setDashboardData(data?.result || {});
      } else {
        setDashboardData({});
        toastMessage(data?.message, "error", "DashboardAnalytics");
      }
    } catch (error) {
      console.error("Error fetching numerical analytics:", error);
      toastMessage("Failed to fetch analytics data", "error", "DashboardAnalytics");
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
      fetchDashboardAnalytics();
  }, []);

  // Format number for display
  const formatNumber = (value) => (value ? Number(value).toFixed(2) : "0.00");

  return (
    <>
      {loader}
      <div className="">
        <div className="">
          <Typography variant="h5" className="mt-4">
            Dashboard Analytics
          </Typography>

          <div className="mt-4 d-flex flex-wrap gap-3">
            <div className="  block_user_button user_dashboad_button ">
              <button className="d-flex flex-column align-items-center">
                <span>Total Users</span>
                <b> {dashboardData.totalUsers || 0}</b>
              </button>
            </div>
            <div className="  block_user_button user_dashboad_button ">
              <button className="d-flex flex-column align-items-center">
                <span>Total Time Spent</span>
                <b> {dashboardData.totalTimeSpent || 0}</b>
              </button>
            </div>
            <div className="  block_user_button user_dashboad_button ">
              <button className="d-flex flex-column align-items-center">
                <span>Average Time Spent</span>
                <b> {Math.round(dashboardData.averageTimeSpent) || 0} Sec</b>
              </button>
            </div>
            <div className="  block_user_button user_dashboad_button ">
              <button className="d-flex flex-column align-items-center">
                <span>Repeat Users</span>
                <b> {dashboardData.repeatUsers || 0}</b>
              </button>
            </div>
            <div className="  block_user_button user_dashboad_button ">
              <button className="d-flex flex-column align-items-center">
                <span>Mantra</span>
                <b> {dashboardData.categoryMetrics?.Mantra?.totalTimeSpent || 0}</b>
              </button>
            </div>
            <div className="  block_user_button user_dashboad_button ">
              <button className="d-flex flex-column align-items-center">
                <span>Music</span>
                <b> {dashboardData.categoryMetrics?.Music?.totalTimeSpent || 0}</b>
              </button>
            </div>
          </div>

        </div>
      </div>

    </>
  );
};

export default DashboardAnalytics;
